// extracted by mini-css-extract-plugin
export var logo = "_kp-2";
export var logoWrapper = "_kp-1";
export var strip = "_kp-0";